/**
 * Tríade Reduzida / Convencional / Ampliada no formulário de ambientes.
 * Manter alinhado com `App\Support\FeatureFlags::AMBIENCE_CAPACITY_TRIAD_ENABLED` (PHP).
 */
export const FEATURE_AMBIENCE_CAPACITY_TRIAD_ENABLED = true
